export default __webpack_public_path__ + "static/media/Venue.d342c27e.svg";